import React from 'react';
import {ForgotPasswordForm} from "../../components/forms";
import {Link, PageAnimator, StripeBG} from '../../components/';
import * as Paths from '../../constants/Paths'
import {seoPageChange} from '../../utils'

class ForgotPasswordPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      success: false
    }
  }

  componentDidMount() { seoPageChange() }

  render() {

    const { success } = this.state;

    return (
      <div className="LoginPage grid-row grid-column v-align h-align full-height">
        <StripeBG />
        <PageAnimator>
          <div className="form form-page">
            <div className="f1 t-center f-strong f-subdued s8">Password Reset</div>
            <div className="login-form s6">
              {!success ? (
                <ForgotPasswordForm onSuccess={(model) => this.setState({success: true}) } />
              ) : (
                <div className="pt-callout pt-intent-primary">
                  We've sent you an email to reset your password. Please check your inbox.
                </div>
              )}
            </div>
            <div className="s1">
              <Link href={Paths.LOGIN} className="f4">
                <span className="pt-icon-standard pt-icon-arrow-left" />Back to login</Link>
            </div>
          </div>
        </PageAnimator>
      </div>
    );
  }
}

export default ForgotPasswordPage;


// WEBPACK FOOTER //
// ./src/pages/account/forgotpassword.js